// extracted by mini-css-extract-plugin
export default {"DropArea":"styles_DropArea__T2DZy","CropWrapper__actions":"styles_CropWrapper__actions__4TQk6","CropWrapper":"styles_CropWrapper__nsFKJ","explainer":"styles_explainer__H9J5L"};